<template>
  <div class="description">
    <KaaliDescription
      v-if="type === 'kaali'"
      :excerpt="excerpt"
      :description="description"
    />
    <WellsDescription
      v-if="type === 'wells'"
      :excerpt="excerpt"
      :description="description"
    />
  </div>
</template>

<script>
import KaaliDescription from '@/components/general-ui/descriptions/Kaali.vue';
import WellsDescription from '@/components/general-ui/descriptions/Wells.vue';
export default {
  name: 'Description',
  components: {
    KaaliDescription,
    WellsDescription
  },
  props: {
    excerpt: String,
    description: String
  },
  data() {
    return {
      type: ws_vue_store.config['single-product-description'],
    };
  },
  computed: {}
};
</script>
